import { render, staticRenderFns } from "./oxxo-payment.vue?vue&type=template&id=5827b23d&scoped=true&"
import script from "./oxxo-payment.vue?vue&type=script&lang=js&"
export * from "./oxxo-payment.vue?vue&type=script&lang=js&"
import style0 from "./oxxo-payment.vue?vue&type=style&index=0&id=5827b23d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5827b23d",
  null
  
)

export default component.exports